import React, { useEffect, memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga4';

import ErrorPage from '@components/site-error-page';

import { fetchConfig, fetchConfigUpdate } from './actions';

import { getConfig } from './selectors';
import { getMapCategory } from '@selectors/data-types-selector';
import { getAgencyTypes } from '@selectors/entities-selector';

const ConfigurationLoader = ({children}) => {
  const dispatch = useDispatch();
  const config = useSelector(getConfig);
  const authValid = useSelector(state => state.auth.valid || false);
  const agencyTypes = useSelector(getAgencyTypes);
  const categoryValues = useSelector(getMapCategory);

  const [pendingUpdate, setPendingUpdate] = useState(true);

  const {siteError, siteLoaded, GOOGLE_ANALYTICS_KEY} = config;

  useEffect(() => {
    if (!siteLoaded) {
      setPendingUpdate(true);
      dispatch(fetchConfig());
    }
  }, [dispatch, siteLoaded, setPendingUpdate]);

  useEffect(() => {
    if (GOOGLE_ANALYTICS_KEY && siteLoaded) {
      ReactGA.initialize(GOOGLE_ANALYTICS_KEY);
      ReactGA.send({
        hitType: 'pageview',
        page: `${window.location.pathname}${window.location.search}`
      });
    }
  }, [dispatch, GOOGLE_ANALYTICS_KEY, siteLoaded]);

  useEffect(() => {
    if (siteLoaded && authValid && agencyTypes && categoryValues && pendingUpdate) {
      dispatch(fetchConfigUpdate(agencyTypes, categoryValues));
      setPendingUpdate(false);
    }
  }, [dispatch, siteLoaded, authValid, agencyTypes, categoryValues, pendingUpdate, setPendingUpdate]);

  if (siteError) {
    return <ErrorPage/>;
  }
  if (!siteLoaded) {
    return null;
  }
  return children;
};

ConfigurationLoader.propTypes = {
  children: PropTypes.node
};

export default memo(ConfigurationLoader);
